import styled from 'styled-components';
import ColorSF2 from './ColorSF2';

/**
 * SFボタンコンポーネント
 * @param width string 他の指定より優先。指定する場合は単位を付ける。デフォルトは100px
 * @param height string 他の指定より優先。指定する場合は単位を付ける。デフォルトは32px
 * @param small boolean width:60px,height:24px,font-size:12px
 * @param large boolean width:150px,height:50px,font-size:14px
 * @param bgColor string 他の指定より優先。デフォルトはlightGreen(#50BD64)
 * @param color string 他の指定より優先。デフォルトはwhite
 * @param borderColor string 他の指定より優先。デフォルトはborder無し
 * @param fontSize string 他の指定より優先。デフォルトは14px
 * @param bold boolean font-weightをboldにする
 * @param defaultCursor boolean デフォルトカーソルを指定する
 * @param disabled boolean デフォルトカーソル、opacityに0.5を設定する
 */
const AppButton = styled.button`
  margin: 4px;
  width: ${props =>
    props.width ||
    (props.small && '60px') ||
    (props.large && '150px') ||
    '100px'};
  height: ${props =>
    props.height ||
    (props.small && '24px') ||
    (props.large && '50px') ||
    '32px'};
  padding: 0px 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${props => props.bgColor || `${ColorSF2.green}`};
  color: ${props => props.color || `${ColorSF2.white}`};
  border: ${props =>
    (props.borderColor && `1px solid ${props.borderColor}`) || 'none'};
  border-radius: 5px;
  font-size: ${props =>
    props.fontSize ||
    (props.small && '12px') ||
    (props.large && '14px') ||
    '14px'};
  font-weight: ${props => (props.bold && 'bold') || 'normal'};
  white-space: nowrap;
  cursor: ${props =>
    ((props.defaultCursor || props.disabled) && 'default') || 'pointer'};
  opacity: ${props => props.disabled && 0.5};
`;
export default AppButton;
